module.exports = __webpack_public_path__ + "img/flag.10c11459.svg";